import { Box, ImageListItem, ImageListItemBar } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import * as Storage from "firebase/storage";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSearchValue } from "../../actions/screen";
import { NoImage } from "../../components/no-image/NoImage";
import { DASHBOARD_RENTALS } from "../../constants/routes";
import type { PricingPlan } from "../../domain/city";
import type { Rental } from "../../domain/rental";
import { constructImageDirectory } from "../../utils/utils";

interface Props {
  rental: Rental;
  cityCode: string;
  plans: PricingPlan[];
}

export const RentalsGalleryItem = ({ rental, cityCode, plans }: Props) => {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();

  const navigateToRental = () => {
    dispatch(setSearchValue(rental.id));
    window.open(`${DASHBOARD_RENTALS}?search=${rental.id}`, "_blank");
  };

  useEffect(() => {
    const planType = plans.find((p) => p.id === rental.planId)?.type;
    if (!planType) {
      return;
    }

    setLoading(true);

    const directory = constructImageDirectory({
      cityCode,
      pricingPlanType: planType,
      id: rental.id,
    });

    const storage = Storage.getStorage();
    const storageRef = Storage.ref(storage, directory);

    Storage.list(storageRef, { maxResults: 1 })
      .then(({ items: [item] }) => {
        return item ? Storage.getDownloadURL(item) : "";
      })
      .then((url) => {
        setUrl(url);
      })
      .finally(() => setLoading(false));
  }, [cityCode, plans, rental.id, rental.planId]);

  if (loading) return <CircularProgress size={50} />;

  return (
    <>
      <ImageListItem>
        {url ? (
          <img src={url} alt="" />
        ) : (
          <Box sx={{ height: 300 }}>
            <NoImage />
          </Box>
        )}
        <ImageListItemBar
          title={
            <Button variant="contained" onClick={navigateToRental}>
              {rental.id}
            </Button>
          }
          actionIcon={
            url ? (
              <Button onClick={() => setShowPreview(true)}>View</Button>
            ) : null
          }
        />
      </ImageListItem>

      <Dialog
        open={showPreview}
        onClose={() => setShowPreview(false)}
        maxWidth="md"
      >
        <DialogContent>
          {url && <img src={url} style={{ width: "100%", height: "auto" }} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
